import { FC, useEffect, useMemo, useState } from 'react';
import Button from '@mui/material/Button';
import { useUserStore } from '../../stores/userStore';
import { UserService } from '../../services/UserService';
import DataTable from '../../components/DataTable/DataTable';
import _ from 'lodash';
import { Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


interface UsersProps {

}

const Users: FC<UsersProps> = ({ }: UsersProps) => {
  const userStore = useUserStore();
  const [users, setUsers] = useState<any[]>([])
  const userService = new UserService();
  const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş

  useEffect(() => {
    if (userStore.users.length > 0) {
      setUsers(userStore.users.map((user, index) => ({
        ...user,
        index: index + 1,
      })))
    }
  }, [userStore.users]);


  // Silme işlemi fonksiyonu
  const handleDelete = (userID: string) => {
    console.log(`Kullanıcı ${userID} silindi!`);
    // Burada silme işlemi gerçekleştirilebilir
  };

  return (
    <>
      <div className="section title-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title d-flex justify-content-start align-items-center">
                <div className="title-icon"><i className="bi bi-person-down"></i></div>
                <div className="title-content">
                  <h1>{t('members')}</h1>
                  <p>{t('filterMembers')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section section-filter my-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card-block card-block-02">
                <h2 className="card-title">{t('searchMember')}</h2>
                <div className="card-content">
                  <div className="row">
                    <DataTable
                      data={users}
                      columns={[
                        {
                          accessorKey: 'index',
                          header: 'ID',
                          size: 20,
                        },
                        {
                          accessorKey: 'createdAt',
                          header: t('members'),
                          size: 120,
                          Cell: ({ cell }) => (
                            <Typography>{moment(cell.row.original.createdAt).format('DD.MM.YYYY')}</Typography>
                          ),
                        },
                        {
                          accessorKey: 'email',
                          header: t('email'),
                          size: 120,
                        },
                        {
                          accessorKey: 'userAction',
                          header: t('delete'),
                          size: 100,
                          Cell: ({ cell }) => (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleDelete(cell.row.original.userID)}
                            >
                           {t('delete')}
                            </Button>
                          ),
                        },
                      ]}
                       />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
